import { UserDetails, ManageUser } from "../../../pages";
import adminRouteMap from "../../../routeControl/adminRouteMap";

export default function route() {
  return [
    {
      path: adminRouteMap.MANAGE_USER.path,
      name: "Manage User",
      key: adminRouteMap.MANAGE_USER.path,
      private: true,
      belongsToSidebar: true,
      icon: adminRouteMap.MANAGE_USER.icon,
      element: <ManageUser />,
    },
    {
      path: adminRouteMap.USER_DETAILS.path,
      name: "User Details",
      key: adminRouteMap.USER_DETAILS.path,
      private: true,
      element: <UserDetails />,
    },
    {
      path: `${adminRouteMap.USER_DETAILS.path}/:id`,
      name: "User Details",
      key: `${adminRouteMap.USER_DETAILS.path}/:id`,
      private: true,
      element: <UserDetails />,
    },
  ];
}
